import React, {useState, useEffect} from "react";
import {Document, Page, pdfjs} from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

export const PDFViewer = ({url}) => {
  const [numPages, setNumPages] = useState(null);
  const [pageWidth, setPageWidth] = useState(null);
  const onDocumentLoadSuccess = ({numPages}) => {
    setNumPages(numPages);
  };
  useEffect(() => {
    if (window.innerWidth < 500) {
      setPageWidth(window.innerWidth - 32); // Adjust as needed
    } else {
      setPageWidth(null); // Use default width
    }
  }, []);
  return (
    <div>
      <Document file={{url}} onLoadSuccess={onDocumentLoadSuccess}>
        {Array.from(new Array(numPages), (el, index) => (
          <Page key={`page_${index + 1}`} pageNumber={index + 1} width={pageWidth} />
        ))}
      </Document>
    </div>
  );
};
